import React from 'react';
import {Link} from "react-router-dom";
import {connect} from "react-redux";

export class HomePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props
        };
    }

    render() {
        console.log("HomePage props = " + JSON.stringify(this.props, null, 2));
        return (
            <div className='content'>
                <div className='nestDiv'>
                    <img className="bigNest" src='/images/Nestlarge.png'/>
{/*
                    <Link className='nav__link' to='/enrollment'>
                        <img className='infoNest1' src='/images/Nestlarge.png'/>
                        <img className='infoNest1Floater' src='/images/enrollment.png'/>
                    </Link>
*/}
                    {/*<Link className='nav__link' to='/covid'>*/}
                    {/*    <img className='infoNest2' src='/images/Nestlarge.png'/>*/}
                    {/*    <img className='infoNest2Floater' src='/images/covid19.png'/>*/}
                    {/*</Link>*/}
                    {/*<Link className='nav__link' to='/tours'>*/}
                    {/*    <img className='infoNest3' src='/images/Nestlarge.png'/>*/}
                    {/*    <img className='infoNest3Floater' src='/images/tours.png'/>*/}
                    {/*</Link>*/}
                </div>
                <div className='floatDiv'>
                    <h1 className='homeHeader'>Everyone is Welcome!</h1>
                    <h3 className='newsBulletin'>
                        Currently Enrolling<br/>
                        Tours are now available!  Please <a href="mailto:tracy.littlenest@yahoo.com">email tracy.littlenest@yahoo.com</a> for tour information.<br/>

                    </h3>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    console.log("HomePage state = " + JSON.stringify(state, null, 2));
    return (
        {
            wordOfDay: state.wordOfDay.wordOfDay
        }
    )
};

export default connect(mapStateToProps, undefined)(HomePage);



// WEBPACK FOOTER //
// ./src/components/HomePage.js